//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RIFLE_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Renal/Chart_RIFLE_info.vue